import { font } from '@approvalmax/ui';
import styled from 'styled-components';

export const Root = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const Request = styled.div`
    overflow: auto;
    display: flex;
    flex-flow: column;
`;

export const Toolbar = styled.div`
    flex: none;
    padding: 25px 60px 30px 60px;
    border-bottom: 1px solid #cacccd;
`;

export const ToolbarHeader = styled.div`
    display: flex;
    align-items: center;
`;

export const ToolbarHeaderTextContainer = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    gap: 8px;
`;

export const ToolbarHeaderText = styled.div`
    text-transform: uppercase;
    ${font(20, '#333333', 'standard')}
`;
